<template>
  <div>
    <BaseButton @click="onPrintReceipt">
      <Icon icon="heroicons:printer-solid" class="h-4 w-4" />
      Cetak Surat Tanda Terima
    </BaseButton>
    <VueHtml2pdf
      v-if="order"
      :show-layout="false"
      :float-layout="true"
      :preview-modal="true"
      :enable-download="true"
      :paginate-elements-by-height="5000"
      :filename="filename"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="210mm"
      ref="printStockMovementEl"
    >
      <LayoutPrintStockMovementReceipt
        slot="pdf-content"
        display-per-product
        :details="movementDetails.data"
        :stock-movement="stockMovement.data"
        :order="{
          id: order.id,
          code: order.attributes.origin_code,
          date: order.attributes.orderedAt || order.attributes.createdAt,
          destinationOfficeCode: destinationOffice
            ? destinationOffice.attributes.code
            : '-',
          destinationOfficeName: destinationOffice
            ? destinationOffice.attributes.name
            : '-',
          destinationOfficeAddress,
          orderAddress,
          type: orderType,
          shipmentType: order.attributes.order_shipment,
        }"
      />
    </VueHtml2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import LayoutPrintStockMovementReceipt from '@/layouts/LayoutPrintStockMovementReceipt.vue';
import { requestMixin } from '../../mixins/request/request.js'
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  mixins: [requestMixin],
  components: { VueHtml2pdf, LayoutPrintStockMovementReceipt },
  props: {
    stockMovementId: String 
  },
  data() {
    return {
      stockMovement: {
        data: {
          attributes: {},
          relationships: {
            order: {
              data: null
            }
          }
        },
        included: []
      },
      movementDetails: {
        data: []
      }
    }
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    filename() {
      const datetime = dayjs(this.order.attributes.createdAt).format('YYYYMMDD')
      const type = 'sppb'
      const code = `${this.order.attributes.origin_code}_${this.order.attributes.destination_code}`
      const user = this.me.office_code

      return [datetime, type, code, user].join('-')
    },
    order() {
      const order = this.stockMovement.data.relationships.order.data

      if (!order) {
        return null
      }

      return this.getSingleIncluded(this.stockMovement, order.id)
    },
    destinationOffice() {
      const destinationOffice =
        this.stockMovement.data.relationships['destination-office'].data;

      if (!destinationOffice) {
        return null;
      }

      return this.getSingleIncluded(this.stockMovement, destinationOffice.id);
    },
    destinationOfficeAddress() {
      if (!this.destinationOffice) {
        return null
      }

      return `${this.destinationOffice.attributes.name}, ${this.destinationOffice.attributes.phone ?? ''}, ${this.destinationOffice.attributes.full_address}`
    },
    orderAddress() {
      if (!this.order) {
        return null
      }
      
      return this.order.attributes.complete_shipment_address
    },
    orderType() {
      if (this.stockMovement.data.attributes.for_reimbursement) {
        return 'Reimbursement'
      }

      if (this.stockMovement.data.attributes.for_free_reimbursement) {
        return 'Susulan Promo'
      }

      if (this.order.attributes.is_transfer_promo || this.order.attributes.is_transfer_promo_regular) {
        return 'Kirim Promo'
      }

      if (!this.destinationOffice) {
        return 'Penjualan'
      }

      if (['stockist_center', 'kantor_pelayanan'].includes(this.destinationOffice.attributes.office_type)) {
        return 'Restock'
      }

      return 'Penjualan'
    },
  },
  methods: {
    onPrintReceipt() {
      setTimeout(() => this.$refs.printStockMovementEl.generatePdf(), 0);
    },
    async loadMovementDetails() {
      const [res, err] = await this.request(`/api/v1/stock-movements/${this.stockMovementId}/movement-details`, {
        params: {
          'fields[movement-details]': 'packet_code,product_code,product_name,product_type,shipped_product_qty,product_weight'
        }
      })

      if (!err) {
        this.movementDetails = res
      }
    },
    async loadStockMovement() {
      const [res, err] = await this.request(`/api/v1/stock-movements/${this.stockMovementId}`, {
        params: {
          include: 'order,destination-office'
        }
      })

      if (!err) {
        this.stockMovement = res
      }
    }
  },
  created() {
    this.loadStockMovement()
    this.loadMovementDetails()
  }
}
</script>
